export type MarketplaceEventName =
  | 'marketplace_view'
  | 'marketplace_search_submitted'
  | 'marketplace_category_selected'
  | 'marketplace_listing_opened'
  | 'marketplace_seller_profile_opened'
  | 'marketplace_filter_applied'
  | 'marketplace_sort_changed'
  | 'seller_cta_clicked'
  | 'checkout_started';

type MarketplaceEventProperties = Record<
  string,
  string | number | boolean | null | undefined
>;

const sanitizeProperties = (properties: MarketplaceEventProperties) =>
  Object.fromEntries(
    Object.entries(properties).filter(([, value]) =>
      ['string', 'number', 'boolean'].includes(typeof value) || value === null,
    ),
  );

export const trackMarketplaceEvent = (
  name: MarketplaceEventName,
  properties: MarketplaceEventProperties = {},
) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent('wersee:marketplace-analytics', {
      detail: {
        name,
        properties: sanitizeProperties(properties),
      },
    }),
  );
};
